// extracted by mini-css-extract-plugin
export default {"wrapper":"FlagImage_wrapper__JBfcs","flagImage":"FlagImage_flagImage__bOByo"};